var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
import axios from 'axios';
import {conditionsUrl} from '../../config/url';

export default {

    getConditions() {
        return axios.get(conditionsUrl).then(response => response.data).catch(() => '');
    },

    appendRequestParameters(link, params) {
        return params.reduce((prev, curr, index) => {
            if (index === 0) {
                return `${prev}${encodeURI(curr.key)}=${encodeURI(curr.value)}`;
            } else {
                return `${prev}&${encodeURI(curr.key)}=${encodeURI(curr.value)}`;
            }
        }, `${link}?`);
    }
};
